module.exports = __webpack_public_path__ + "static/media/custom-checkbox-1-checked.b1be5ebc.svg";